var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Worker50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00897b",
    d: "M29,33L29,33l-5,1l-5-1c0,0-11,1.986-11,13h32C40,35.025,29,33,29,33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M24 39L19 33 19 27 29 27 29 33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M35,21c0,1.106-0.896,2-2,2c-1.106,0-2-0.894-2-2c0-1.105,0.894-2,2-2C34.104,19,35,19.895,35,21 M17,21c0-1.105-0.896-2-2-2c-1.106,0-2,0.895-2,2c0,1.106,0.894,2,2,2C16.104,23,17,22.106,17,21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M33,15c0-7.635-18-4.971-18,0v7c0,4.971,4.028,9,9,9c4.971,0,9-4.029,9-9V15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M24,6c-6.075,0-10,4.926-10,11v2.286L16,21v-5l12-4l4,4v5l2-1.742V17c0-4.025-1.038-8.016-6-9l-1-2H24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#784719",
    d: "M27,21c0-0.551,0.448-1,1-1s1,0.449,1,1c0,0.551-0.448,1-1,1S27,21.551,27,21 M19,21c0,0.551,0.448,1,1,1s1-0.449,1-1c0-0.551-0.448-1-1-1S19,20.449,19,21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M30,33.254V42H18v-8.749c-0.945,0.28-2.445,0.823-4,1.791V42v2v2h20v-2v-2v-6.941C32.444,34.086,30.944,33.536,30,33.254z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M18,42L18,42h-4l0,0v-3l0,0h4l0,0V42z M34,39L34,39h-4l0,0v3l0,0h4l0,0V39z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5722",
    d: "M34,15v-1c0-4.971-4.029-9-9-9h-2c-4.971,0-9,4.029-9,9v1h-2v3h24v-3H34z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#d84315",
    d: "M21 4H27V15H21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Worker50);
export default __webpack_public_path__ + "static/media/icons8-worker-50.885ac8f6a7f349d572a59a13dd37f8e3.svg";
export { ForwardRef as ReactComponent };